// StatusCell — icon + word status display (A41 color-blind rule: never color alone).
// Colors use theme tokens; status meaning communicated by icon+word, never color alone.
const STATUS_CONFIG = {
  draft:            { icon: '○', label: 'Draft',            color: 'var(--th-status-draft)' },
  in_progress:      { icon: '◐', label: 'In Progress',      color: 'var(--th-status-inprogress)' },
  validated_db:     { icon: '✓', label: 'Validated DB',     color: 'var(--th-status-validated)' },
  validated_synced: { icon: '✓✓', label: 'Validated Synced', color: 'var(--th-status-synced)' },
  deprecated:       { icon: '✗', label: 'Deprecated',        color: 'var(--th-status-deprecated)' },
};

export default function StatusCell({ value }) {
  const cfg = STATUS_CONFIG[value] || { icon: '?', label: value || '—', color: 'var(--th-status-draft)' };
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      color: cfg.color, fontSize: 'inherit', whiteSpace: 'nowrap',
    }}>
      <span aria-hidden="true" style={{ fontFamily: 'var(--ff-mono)' }}>{cfg.icon}</span>
      <span>{cfg.label}</span>
    </span>
  );
}
